import http from './http'

export default class myLicenceApi {
  static getStatus(endpoint) {
    return http.get(endpoint)
  }
}
